import { API_BASE_URL } from "./api";

export function buildChatSocketUrl({
  poolCode,
  ticket,
  baseUrl = API_BASE_URL,
}: {
  poolCode: string;
  ticket: string;
  baseUrl?: string;
}) {
  const resolvedBaseUrl =
    baseUrl || (typeof window !== "undefined" ? window.location.origin : "http://localhost:8000");
  const parsed = new URL(resolvedBaseUrl);
  parsed.protocol = parsed.protocol === "https:" ? "wss:" : "ws:";
  parsed.pathname = "/ws/chat";
  parsed.search = "";
  parsed.searchParams.set("pool_code", poolCode);
  parsed.searchParams.set("ticket", ticket.trim());
  return parsed.toString();
}
